import ChatContent from './ChatContent';
export default ChatContent; 